import { render, staticRenderFns } from "./ForumClassroom.vue?vue&type=template&id=04171649&scoped=true&"
import script from "./ForumClassroom.vue?vue&type=script&lang=js&"
export * from "./ForumClassroom.vue?vue&type=script&lang=js&"
import style0 from "./ForumClassroom.vue?vue&type=style&index=0&id=04171649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04171649",
  null
  
)

export default component.exports